import React, { useState, useEffect } from "react";
import useFirebase from "../../../../../useFirebase";
import { useSelector, useDispatch } from "react-redux";
import useWebMonitor from "./useWebMonitor";
import WebCategoryInfo from "./WebCategoryInfo";
import RestrictedWebsiteInfo from "./RestrictedWebsiteInfo";
import AllowedWebsitesInfo from "./AllowedWebsitesInfo";
import { useHistory } from "react-router-dom";
import { setRuleDataSetUp } from '../../../AxiosRtk/SetRules/setRulesAction';

const WebMonitoring = ({ deviceSelected, getLangTranslation }) => {
  const [webMonitoringData, setWebMonitoring] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const { getCollectionData } = useFirebase(deviceSelected);

  const { handleToggleChange } = useWebMonitor(
    deviceSelected,
    webMonitoringData,
    setWebMonitoring
  );

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected]);

  useEffect(() => {
    if (setRulesData) {
      setWebMonitoring(setRulesData?.webmonitoring);
    } else {
      setRuleDataSetUp(null);
    }
  }, [setRulesData]);


  if (!deviceSelected) {
    return (
      <div className='text-center my-3'>
        -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
      </div>
    )
  }

  return (
    <>
      <div
        className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        <div>
          <h6 className="mb-0">
            {
              getLangTranslation("WEB_MONITORING_ENABLE_WEB_MONITORING_DESCRIPTION", " Web monitoring work only on Chrome browser, we will block any other browser available on child’s device or downloaded by him.")
            }
          </h6>
          {/* <span className="text-small text-dark">
            {getLangTranslation("WE_SUGGEST_PARENT_MONITOR_NEW_APPS_INSTALLED_BY_CHILD", "We suggest parent to monitor new apps installed by child, and in case of new browser not blocked by default by Kido Protect we highly recommend parent to block it or delete it from the parent app.")}
          </span> */}
        </div>
        {/* <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button> */}
      </div>
      <div className="d-flex align-items-center justify-content-between gap-3">
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            id="WEB_MONITORING_ENABLE"
            name="WEB_MONITORING_ENABLE"
            type="checkbox"
            role="switch"
            checked={webMonitoringData?.webMonitoringEnabled || false}
            onChange={handleToggleChange}
          />
          <label
            className="form-check-label text-blue-800 fw-semibold"
            htmlFor="WEB_MONITORING_ENABLE"
          >
            {getLangTranslation("SETRULE_WEB_MONITORING", "Web monitoring")}
          </label>
        </div>
      </div>
      {webMonitoringData?.webMonitoringEnabled && (
        <>
          <hr className="my-6" />
          <h5 className="mb-6">
            {getLangTranslation("WEB_MONITORING_HOW_DO_YOU_WANT_TO_SUPERVISE", "How do you want to supervise the web activity?")}
          </h5>
          <div className="row">
            <div className="col-lg-4">
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  id="ALLOW_ALL_MONITOR_ONLY"
                  type="radio"
                  name="ALLOW_ALL_MONITOR_ONLY"
                  checked={webMonitoringData?.webSupervisionType === 0}
                  onChange={handleToggleChange}
                />
                <label
                  className="form-check-label text-blue-800 fw-semibold"
                  htmlFor="ALLOW_ALL_MONITOR_ONLY"
                >
                  {getLangTranslation("SETUP_WIZARD_ALLOW_ALL", "Allow all and monitor only")}
                </label>
              </div>
              <h6 className="text-dark fw-normal">
                {getLangTranslation("WEB_MONITORING_ALLOW_AND_MONITOR_ONLY_DESCRIPTION", "If you select this option, then selected categories and websites will be allowed, and the activity monitored for you. When your child tries to access a blocked website, you will be alerted.")}
              </h6>
            </div>
            <div className="col-lg-4">
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  id="BLOCK_SELECTED_WEBSITES"
                  type="radio"
                  name="BLOCK_SELECTED_WEBSITES"
                  checked={
                    webMonitoringData?.webSupervisionType === null ||
                    webMonitoringData?.webSupervisionType === 1
                  }
                  onChange={handleToggleChange}
                />
                <label
                  className="form-check-label text-blue-800 fw-semibold"
                  htmlFor="BLOCK_SELECTED_WEBSITES"
                >
                  {getLangTranslation("WEB_MONITORING_BLOCK_SELECTED_CATEGORIES", "Block selected websites and categories")}
                </label>
              </div>
              <h6 className="text-dark fw-normal">
                {getLangTranslation("WEB_MONITORING_BLOCK_SELECTED_CATEGORIES_DESCRIPTION", "If you select this option then selected categories and websites will be blocked")}
              </h6>
            </div>
            <div className="col-lg-4">
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  id="BLOCK_ALL"
                  name="BLOCK_ALL"
                  type="radio"
                  checked={webMonitoringData?.webSupervisionType === 2}
                  onChange={handleToggleChange}
                />
                <label
                  className="form-check-label text-blue-800 fw-semibold"
                  htmlFor="BLOCK_ALL"
                >
                  {getLangTranslation("WEB_MONITORING_BLOCK_ALL", "Block all")}
                </label>
              </div>
              <h6 className="text-dark fw-normal">
                {getLangTranslation("WEB_MONITORING_BLOCK_ALL_DESCRIPTION", "If you select this option then selected categories and websites will be blocked, only websites you had added in exceptions list will be allowed.")}
              </h6>
            </div>
          </div>
          <hr className="my-6" />
          <div className="form-check form-switch mb-4">
            <input
              className="form-check-input"
              id="SAFE_SEARCH"
              name="SAFE_SEARCH"
              type="checkbox"
              role="switch"
              checked={webMonitoringData?.safeSearch || false}
              onChange={handleToggleChange}
            />
            <label className="form-check-label" htmlFor="SAFE_SEARCH">
              <span className="text-dark fw-semibold">
                {getLangTranslation("WEB_MONITORING_SAFE_SEARCH", "Safe Search")}
                <span className="text-small text-gray mx-3 fw-normal">
                  {getLangTranslation("WEB_MONITORING_SAFE_SEARCH_DESCRIPTION", "Block inappropriate result from search results.")}                  
                </span>
              </span>
            </label>
          </div>
          <div className="mb-4">
            <div className="form-check form-switch mb-2">
              <input
                className="form-check-input"
                id="SAFE_SEARCH_YOUTUBE"
                name="SAFE_SEARCH_YOUTUBE"
                type="checkbox"
                role="switch"
                checked={webMonitoringData?.safeSearchYoutube || false}
                onChange={handleToggleChange}
              />
              <label className="form-check-label" htmlFor="SAFE_SEARCH_YOUTUBE">
                <span className="text-dark fw-semibold">
                  {getLangTranslation("WEB_MONITORING_SAFE_SEARCH_YOUTUBE", "Block inappropriate searches on YouTube")}
                </span>
              </label>
            </div>
            <p className="text-small text-gray mb-0">
              {getLangTranslation("WEB_MONITORING_SAFE_SEARCH_YOUTUBE_DESCRIPTION", "Block inappropriate result from search results. Check the list of Safe Search keywords.You can suggest more keywords by sending us email or on chat module")}              
            </p>
            <span
              className="text-small text-primary pt-cursor"
              onClick={() => history.push("/set-rules/edit-keywords")}
            >
              {getLangTranslation("WEB_MONITORING_SAFE_SEARCH_YOUTUBE_LINK_TO_KEYWORDS", "Edit your keywords")}
            </span>
          </div>

          <div className="form-check form-switch mb-4">
            <input
              className="form-check-input"
              id="ENFORCE_SAFE_SEARCH_GOOGLE"
              name="ENFORCE_SAFE_SEARCH_GOOGLE"
              type="checkbox"
              role="switch"
              checked={webMonitoringData?.enforceSafeSearchGoogle || false}
              onChange={handleToggleChange}
            />
            <label
              className="form-check-label"
              htmlFor="ENFORCE_SAFE_SEARCH_GOOGLE"
            >
              <span className="text-dark fw-semibold">
                {getLangTranslation("WEB_MONITORING_ENFORCE_SAFE_SEARCH_GOOGLE", "Enforce Safe Search Google, Bing & YouTube")}
                <span className='text-small text-gray mx-3 fw-normal'>{getLangTranslation("WEB_MONITORING_ENFORCE_SAFE_SEARCH_GOOGLE_DESCRIPTION", "This option will block inappropriate content on Google search engine.")}</span>
              </span>
            </label>
          </div>

          <hr className="my-6" />
          <div className="grid gap-3">
            <WebCategoryInfo
              webMonitoringData={webMonitoringData}
              deviceSelected={deviceSelected}
              getLangTranslation = {getLangTranslation}
            />
            <RestrictedWebsiteInfo
              webMonitoringData={webMonitoringData}
              deviceSelected={deviceSelected}
              getLangTranslation = {getLangTranslation}
            />
            <AllowedWebsitesInfo
              webMonitoringData={webMonitoringData}
              deviceSelected={deviceSelected}
              getLangTranslation = {getLangTranslation}
            />
          </div>
        </>
      )}
    </>
  );
};

export default WebMonitoring;
